import { Center, Dialog, Spinner, Text } from '@chakra-ui/react';
import {
  getStatisticLayerStyles,
  trajectoryArrowOutlineLayer,
  trajectoryOutlineLayer,
} from '@components/map/layers/statistics/statistic.layer';
import { useStatisticMapContext } from '@components/map/MapContext';
import { useAppSelector } from '@hooks/redux.hooks';
import { useFindAllWithDetails } from '@hooks/useFindAllNotificationsWithDetails';
import { selectStatisticsCriteria } from '@redux/maps/maps.selectors';
import { FormattedMessage } from 'react-intl';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

export function StatisticLayer() {
  const { filterColorMode, threshold } = useStatisticMapContext();
  const criteria = useAppSelector(selectStatisticsCriteria);
  const { data, isLoading } = useFindAllWithDetails(criteria);
  const {
    trajectory: trajectoryStyle,
    trajectoryArrow: trajectoryArrowStyle,
    statistic: statisticStyle,
  } = getStatisticLayerStyles(filterColorMode, threshold);

  return (
    <>
      <Dialog.Root open={isLoading} placement="center" closeOnEscape={false} closeOnInteractOutside={false}>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Center backgroundColor="neutral.700" padding={4} gap={2}>
              <Spinner />
              <Text textAlign="center">
                <FormattedMessage id="components.notificationSearch.statistics.loading" />
              </Text>
            </Center>
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Root>

      <Source id={SourceNameEnum.STATISTICS} type="geojson" data={data}>
        <Layer {...trajectoryOutlineLayer} />
        <Layer {...trajectoryStyle} />
        <Layer {...trajectoryArrowStyle} />
        <Layer {...trajectoryArrowOutlineLayer} />
        <Layer {...statisticStyle} />
      </Source>
    </>
  );
}
